/* This file was generated automatically. Do not edit manually. */

export enum GxVirtualKeyCardInReservation {
    AvailableToGet = 0,
    AlreadyIssued = 1,
    NotAvailable = 2,
    WalletAvailable = 3,
}
